var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlasLogoWhiteBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#76AADB"
    },
    d: "M144.26,144.57c0,71.85,0,143.69,0,215.54c4.81-0.01,33.97-0.56,54.18-23.11 c3.19-3.56,15.89-18.13,17.53-39.44c0.29-3.78,0.17-6.95,0-9.16c24.04-0.13,48.07-0.27,72.11-0.4c5.04,0.1,29.22,0.06,49.4-18.73 c22.45-20.89,22.39-48.61,22.31-52.99c-0.13-23.9-0.27-47.81-0.4-71.71c0.2-3.99,1.15-33.33-22.31-54.58 c-20.11-18.22-44.09-17.73-49-17.53c-24.04-0.13-48.07-0.27-72.11-0.4c-4.52,0-32.59,0.47-53.39,23.51 C144.49,115.61,144.19,139.13,144.26,144.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#FFFFFF"
    },
    d: "M215.58,143.77c0,24.17,0,48.34,0,72.51c14.87,0,29.75,0,44.62,0 c3.17,0,13.89-0.41,22.31-8.37c1.72-1.62,5.35-5.13,7.17-10.76c1.44-4.44,0.3-5.73,0.4-16.33c0.1-9.94,1.12-11.01,0-15.54 c-0.23-0.94-1.67-6.5-6.01-11.52c-8.79-10.18-22.46-10.05-24.67-9.99C244.79,143.77,230.19,143.77,215.58,143.77z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110.45,
    y: 166.73,
    style: {
      fill: "#BCD6F0"
    },
    width: 64.59,
    height: 97.01
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EDF9"
    },
    d: "M97.98,114.99L68,128.3v21.4l29.97-13.31l89.53,13.31v-21.4L97.98,114.99z M419.42,101.43 c-8.43-21.9-20.43-40.36-36.05-55.36c-15.6-14.99-34.49-26.43-56.67-34.29C304.54,3.94,279.9,0,252.79,0h-71.72 C127,0,68,50.84,68,113.56v2.14l29.97-13.32l89.53,13.32h56.05c21.77,0,38.71,5.63,50.82,16.88 c12.1,11.25,18.17,27.66,18.17,49.2v1.42c0,20.12-6.07,36.03-18.17,47.76c-12.12,11.74-28.85,17.6-50.2,17.6h-56.67V162.3 l-89.53-13.31L68,162.3v337.68h0.06c0.22,0,0.94-0.01,0.94-0.01c3.78-0.03,7.54-0.26,11.22-0.71c0.52-0.06,1.06-0.13,1.63-0.22 c2.3-0.29,4.59-0.68,6.83-1.14c0.3-0.04,0.6-0.1,0.89-0.17c0.46-0.1,0.91-0.2,1.34-0.32c1.37-0.29,2.71-0.62,4.04-0.98 c0.42-0.1,0.85-0.23,1.27-0.36c0.16-0.03,0.3-0.07,0.46-0.13c0.43-0.12,0.86-0.23,1.3-0.36c20-6,37.99-17.84,52.48-33.87 c0.71-0.78,1.41-1.57,2.12-2.37c0.42-0.49,0.82-1.02,1.24-1.52c0.12-0.14,0.23-0.29,0.35-0.43c1.25-1.51,2.47-3.04,3.66-4.61 c0.27-0.35,0.53-0.72,0.79-1.07c8.64-11.65,15.67-24.95,20.61-39.5c0.17-0.49,0.33-0.98,0.49-1.48c0.22-0.65,0.42-1.3,0.62-1.94 c4.65-14.78,7.18-30.74,7.18-47.38v-4.29h59.14c26.68,0,51.43-3.8,74.22-11.43c22.78-7.61,42.39-19.04,58.81-34.28 c16.43-15.24,29.27-34.05,38.51-56.44c9.24-22.38,13.87-48.32,13.87-77.85v-1.42C432.05,148.1,427.82,123.33,419.42,101.43z  M110.45,166.73l64.59,9.6v35.14l-64.59-9.6V166.73z M110.45,218.99l64.59,9.6v35.15l-64.59-9.61V218.99z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCD6F0"
    },
    d: "M97.98,148.99L68,162.3v337.68c0,0,12.46,0.64,29.97-4.39V148.99z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 97.98,
    y1: 115.36,
    x2: 97.98,
    y2: 136.38
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 97.98,
    y1: 115.36,
    x2: 97.98,
    y2: 136.38
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCD6F0"
    },
    points: "97.98,136.38 68,149.69 68,128.3 97.98,114.99  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M151.7,96.02"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M97.98,96.02"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.5072,
    y1: 323.3726,
    x2: 187.5072,
    y2: 323.3726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E89B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M187.51,323.37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012451519126222742130000001994656208813056936_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.5079,
    y1: 302.8407,
    x2: 236.4049,
    y2: 302.8407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#76AADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "url(#SVGID_00000012451519126222742130000001994656208813056936_)"
    },
    d: "M236.4,357.12h-48.9 c0-13.48,0-26.97,0-40.45c0-22.7,0-45.4,0-68.11c16.3,0,32.6,0,48.9,0V357.12z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171707717360514023520000001660012453096731538_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.3486,
    y1: 441.3996,
    x2: 140.3009,
    y2: 402.4028
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#76AADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3996,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.39,
      fill: "url(#SVGID_00000171707717360514023520000001660012453096731538_)"
    },
    d: "M68.03,430.51 C68.03,430.51,67.9,430.53,68.03,430.51c56.2,0.71,119.48-56.61,119.48-149.01l0,0l0,75.61l0,0 c1.54,88.51-61.34,144.01-119.5,142.86c-0.13,0.01,0,0,0,0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160191527691405377980000009657627923177528746_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.366,
    y1: 237.774,
    x2: 335.7102,
    y2: 246.2091,
    gradientTransform: "matrix(-0.8951 -0.4458 0.4458 -0.8951 320.6938 800.4439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#76AADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.28,
      fill: "url(#SVGID_00000160191527691405377980000009657627923177528746_)"
    },
    d: "M187.51,357.12 c1.86,86.77-59.77,143.7-119.45,142.85c-0.13,0.01,0,0,0,0C90.77,472.76,165.76,383,187.51,357.12L187.51,357.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E76A24"
    },
    d: "M97.92,136.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E76A24"
    },
    d: "M97.92,115.37"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M151.64,96.03"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M97.92,96.03"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083077308085773590670000010105152515766117288_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.4491,
    y1: 323.3858,
    x2: 187.4491,
    y2: 323.3858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E89B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083077308085773590670000010105152515766117288_)"
    },
    d: "M187.45,323.39"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasLogoWhiteBig);
export default __webpack_public_path__ + "static/media/Plas-logo-white-big.e2bcc24b75ef0a6c627483797e3c3658.svg";
export { ForwardRef as ReactComponent };